// Update the Header component with new branding
import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Stethoscope, Menu, X, Phone } from 'lucide-react';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Colleges', path: '/colleges' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-primary-600 py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container-custom flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <Stethoscope 
            size={32} 
            className="text-white mr-2" 
          />
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-white">
              VET Explore
            </h1>
            <p className="text-xs text-secondary-500 -mt-1">Hub</p>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <ul className="flex space-x-6">
            {navLinks.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) => 
                    `font-medium text-white hover:text-white transition-colors ${
                      isActive ? 'border-b-2 border-white' : ''
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
          
          {/* Call Now Button */}
          <a 
            href="tel:+918452055440" 
            className="btn bg-secondary-500 text-primary-800 hover:bg-secondary-600 flex items-center"
          >
            <Phone size={18} className="mr-2" />
            Call Now
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-primary-600 py-4 shadow-lg">
          <div className="container-custom">
            <ul className="space-y-4">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    className={({ isActive }) => 
                      `block py-2 font-medium text-white transition-colors ${
                        isActive ? 'border-b-2 border-white' : ''
                      }`
                    }
                    onClick={() => setIsOpen(false)}
                  >
                    {link.name}
                  </NavLink>
                </li>
              ))}
              <li>
                <a 
                  href="tel:+918452055440" 
                  className="btn bg-secondary-500 text-primary-800 hover:bg-secondary-600 flex items-center justify-center w-full mt-4"
                >
                  <Phone size={18} className="mr-2" />
                  Call Now
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;